import { Component } from '@angular/core';
import { UpsellCardComponent } from '@components/upsell-card/upsell-card.component';
import { UpsellSlugs } from '@enums/upsell-slugs';

@Component({
  selector: 'app-need-a-doctors-note',
  templateUrl: './need-a-doctors-note.component.html',
  imports: [UpsellCardComponent],
})
export class NeedADoctorsNoteComponent {
  public readonly slug: UpsellSlugs = UpsellSlugs.DoctorsNote;
}
